import styled from '@emotion/styled';
import { Box } from '@pairy/pds-react';

export const BoxWrapper = styled(Box)`
  cursor: pointer;

  &:hover {
    box-shadow: ${({ theme }) => theme.elevation.xs};
  }

  transition: box-shadow 0.15s ease-in-out;
`;

export const Line = styled.div`
  width: 1px;
  height: 14px;

  background-color: ${({ theme }) => theme.colors.zinc_200};
`;
